interface RatingType {
  label: string
  start?: number
  end?: number
}

const searchFilterRatingConfig: RatingType[] = [
  { label: 'All' },
  { end: 4, label: '3-4 stars' },
  { start: 4, label: '4-5 stars' },
]

export default searchFilterRatingConfig
